import { render } from "./LoginDemo.vue?vue&type=template&id=42ff5f44"
import script from "./LoginDemo.vue?vue&type=script&lang=js"
export * from "./LoginDemo.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__